export default function About() {
  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>About Us</h1>
      <p>This is the About page. Add your company information here.</p>
    </div>
  );
}
